import { render, staticRenderFns } from "./EventHistoryTable.vue?vue&type=template&id=700b716e"
import script from "./EventHistoryTable.vue?vue&type=script&lang=js"
export * from "./EventHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports